'use strict';

var wrap = function wrap(fn) {
    return function () {
        for (var _len = arguments.length, a = Array(_len), _key = 0; _key < _len; _key++) {
            a[_key] = arguments[_key];
        }

        return function () {
            for (var _len2 = arguments.length, b = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                b[_key2] = arguments[_key2];
            }

            return fn.apply(undefined, a.concat(b));
        };
    };
};

module.exports = function (fn) {
    for (var _len3 = arguments.length, a = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        a[_key3 - 1] = arguments[_key3];
    }

    check(fn);

    if (a.length) return wrap(fn).apply(undefined, a);

    return wrap(fn);
};

function check(fn) {
    if (typeof fn !== 'function') throw Error('fn should be a function!');
}